import { useState } from 'react';
import useLanguage from '../hooks/useLanguage';
import styles from '../assets/styles/ContactForm.module.css';
import { translations } from '../locales/lang';

const ContactForm = () => {
  const { language } = useLanguage();
  const [formData, setFormData] = useState({
    workplace: '',
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className={styles.container} id='contact'>
      <div className={styles.containerBackground}>
        <img src='/images/contact/background.svg' alt='background' />
      </div>
      <div className={styles.containerHeader}>
        <div className={styles.headerText} >
          <h1 className={styles.header} data-aos="fade-right">{translations[language].contact.title}</h1>
          <p className={styles.description} data-aos="fade-right">
            {translations[language].contact.desc}
          </p>
        </div>
        <div className={styles.headerImage} >
          <img src='/images/contact/people.png' data-aos="fade-right" alt='people' />
        </div>
      </div>
      <div className={styles.containerForm} data-aos="fade-right">
        <form className={styles.form}>
          <div className={styles.formGroup}>
            <input
              type="text"
              name="workplace"
              value={formData.workplace}
              onChange={handleChange}
              className={`${styles.input} ${styles.workplace}`}
              placeholder={translations[language].contact.workplace}
            />
          </div>
          <div className={styles.formGroup}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`${styles.input} ${styles.name}`}
              placeholder={translations[language].contact.name}
            />
          </div>
          <div className={styles.formGroup}>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={`${styles.input} ${styles.phone}`}
              placeholder={translations[language].contact.phone}
            />
          </div>
          <div className={styles.formGroup}>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`${styles.input} ${styles.email}`}
              placeholder={translations[language].contact.email}
            />
          </div>
          <div className={styles.formGroup}>
            <textarea
              type="text"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className={`${styles.textarea} ${styles.message}`}
              placeholder={translations[language].contact.message}
            />
          </div>
          <div className={styles.formButton}>
            <button onClick={(e) => e.preventDefault()} className={styles.button}>
              {translations[language].contact.submit}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;